/**
 * upsell-cart.js — Upsell -20% Natura Force (cart drawer + page /cart)
 * Sources : API recommandations Shopify + métadonnée crossell_product des articles du panier.
 * Ne propose que les produits possédant une variante "Offre Upsell (-20%)".
 * Multi-conteneurs : .upsell-cart dans le drawer (liste) ET dans main-cart-footer (grille).
 * Ajout via le pattern sections du thème (pas de reload). Anti-abuse partagé :
 * dès qu'il ne reste aucun produit principal (ni upsell, ni catalogue gratuit), on vide tout.
 *
 * PERF v2 :
 *  - 1 SEUL fetch /cart.js par changement de panier (les données sont passées en paramètre
 *    aux fonctions aval : plus de double/triple fetch).
 *  - Debounce réduit 150ms -> 60ms ; les événements custom:updated/cart:updated sont traités
 *    sans attente supplémentaire.
 *  - Masquage OPTIMISTE : dès qu'il ne reste plus de produit principal, tous les conteneurs
 *    .upsell-cart sont masqués immédiatement (is-empty) ; l'update.js suit en arrière-plan.
 *  - Garde anti-course : avant de réécrire le conteneur, on vérifie qu'il est toujours dans
 *    le DOM (renderContents du thème peut remplacer la section entre-temps).
 */
(function () {
  'use strict';
  if (window.__upsellCartInit) return;
  window.__upsellCartInit = true;

  var retryScheduled = false;
  var knownContainers = [];
  var lastCartFingerprint = null;
  var cartCheckInFlight = false;
  var cartCheckAgain = false;

  function $$(sel, ctx) { return (ctx || document).querySelector(sel); }

  // Un panier "plein" (réponse /cart.js ou /cart/update.js?sections=) expose item_count.
  // La réponse /cart/add.js?sections= ne contient QUE les articles AJOUTÉS (pas item_count)
  // → ne jamais faire de décision anti-abuse ou d'exclusion avec ce panier partiel.
  function isFullCart(c) {
    return !!(c && c.items && c.item_count !== undefined);
  }

  function getCrossellMap() {
    var el = document.getElementById('cart-crossell-data') || document.getElementById('cart-crossell-data-page');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function findUpsellVariant(p, tag) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if ((p.variants[i].title || '').indexOf(tag) !== -1) return p.variants[i];
    }
    return null;
  }

  var recCache = {};
  function fetchRecs(productId, attempt) {
    attempt = attempt || 1;
    if (recCache[productId]) return recCache[productId];
    var p = fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.products || []; })
      .catch(function () {
        if (attempt < 3) {
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(fetchRecs(productId, attempt + 1)); }, 800 * attempt);
          });
        }
        return [];
      });
    recCache[productId] = p;
    return p;
  }

  function imgUrl(src) {
    if (!src) return '';
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function fmt(v) {
    return parseFloat(v).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function getTarget(container) {
    return container.querySelector('.upsell-cart__grid, .upsell-cart__list');
  }

  function hideUpsell(container) {
    container.classList.add('is-empty');
    container.classList.remove('is-loaded');
    var t = getTarget(container);
    var loading = $$('.upsell-cart__loading', container);
    if (t) t.innerHTML = '';
    if (loading) loading.style.display = 'none';
  }

  // Masquage instantané de TOUS les conteneurs (disparition optimiste de l'anti-abuse)
  function hideAllUpsells() {
    document.querySelectorAll('.upsell-cart').forEach(function (c) { hideUpsell(c); });
  }

  // Anti-abuse : un article est-il un "produit principal" ?
  // (ni upsell _upsell, ni catalogue gratuit pointé par data-catalogue-pid)
  function hasRegularItem(cart) {
    var container = document.querySelector('.upsell-cart[data-catalogue-pid]') || $$('.upsell-cart');
    var cataloguePid = container ? (container.dataset.cataloguePid || '') : '';
    return cart.items.some(function (item) {
      if (cataloguePid && String(item.product_id) === String(cataloguePid)) return false;
      return !item.properties || item.properties._upsell !== 'true';
    });
  }

  function loadUpsellProducts(container, cartData) {
    var upsellTag = container.dataset.upsellTag || 'Offre Upsell (-20%)';
    var limit = parseInt(container.dataset.limit, 10) || 3;
    var listEl = getTarget(container);
    var loadingEl = $$('.upsell-cart__loading', container);
    if (!listEl) return;

    function handleCart(cart) {
      if (!cart.items || cart.items.length === 0) { hideUpsell(container); return; }

      var cartProductIds = {};
      cart.items.forEach(function (i) { cartProductIds[String(i.product_id)] = true; });

      var crossellMap = getCrossellMap();
      var handles = [];
      var seen = {};
      cart.items.forEach(function (item) {
        var list = crossellMap[String(item.product_id)];
        if (!list) return;
        list.forEach(function (h) {
          if (h && !seen[h]) { seen[h] = true; handles.push(h); }
        });
      });

      var candidates = handles.slice(0, limit * 2).map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
      });
      var recP = fetchRecs(cart.items[0].product_id);

      Promise.all([Promise.all(candidates), recP]).then(function (res) {
        // Garde anti-course : le thème peut avoir remplacé la section entre-temps
        if (!document.body.contains(container)) return;
        var crossellProducts = res[0].filter(function (p) { return p !== null; });
        var chosen = [];
        var chosenIds = {};

        function tryAdd(p) {
          if (!p) return;
          if (chosen.length >= limit) return;
          if (cartProductIds[String(p.id)] || chosenIds[p.id]) return;
          var uv = findUpsellVariant(p, upsellTag);
          if (!uv) return;
          chosenIds[p.id] = true;
          chosen.push({ product: p, uv: uv });
        }

        crossellProducts.forEach(tryAdd);
        res[1].forEach(tryAdd);

        if (chosen.length === 0) { hideUpsell(container); scheduleRetry(); return; }

        if (loadingEl) loadingEl.style.display = 'none';
        listEl.innerHTML = chosen.map(function (c) {
          var p = c.product, uv = c.uv;
          var orig = ((p.variants && p.variants[0]) ? p.variants[0].price : (p.price || 0)) / 100;
          return '<div class="upsell-cart__item">' +
            '<div class="upsell-cart__image">' + (p.featured_image ? '<img src="' + imgUrl(p.featured_image) + '" alt="' + (p.title || '') + '" loading="lazy">' : '') + '</div>' +
            '<p class="upsell-cart__name">' + (p.title || '') + '</p>' +
            '<div class="upsell-cart__prices">' +
              '<span class="upsell-cart__price--original">' + fmt(orig) + '</span>' +
              '<span class="upsell-cart__price--discount">' + fmt(uv.price / 100) + '</span>' +
            '</div>' +
            '<button class="upsell-cart__add" type="button" data-vid="' + uv.id + '" data-name="' + (p.title || '').replace(/\"/g, '&quot;') + '">+ Ajouter</button>' +
          '</div>';
        }).join('');

        container.classList.remove('is-empty');
        container.classList.add('is-loaded');
        listEl.style.display = '';
        container.dataset.upsellLoaded = '1';
        bindButtons(container);
      });
    }

    if (cartData && cartData.items) {
      handleCart(cartData);
    } else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(handleCart).catch(function () {
        if (loadingEl) loadingEl.style.display = 'none';
        scheduleRetry();
      });
    }
  }

  // Relance différée (une seule) si l'API recommandations a échoué ou n'a rien donné
  function scheduleRetry() {
    if (retryScheduled) return;
    retryScheduled = true;
    setTimeout(function () {
      retryScheduled = false;
      maybeLoadAll();
    }, 2000);
  }

  // Charge les conteneurs .upsell-cart non encore chargés (drawer + page /cart)
  function maybeLoadAll(cartData) {
    document.querySelectorAll('.upsell-cart').forEach(function (c) {
      if (c.dataset.upsellLoaded) return;
      loadUpsellProducts(c, cartData);
    });
  }

  // Détecte l'apparition/remplacement des conteneurs (re-rendu de section)
  function syncContainers(cartData) {
    var fresh = Array.prototype.slice.call(document.querySelectorAll('.upsell-cart'));
    var changed = fresh.length !== knownContainers.length ||
      fresh.some(function (c, i) { return c !== knownContainers[i]; });
    knownContainers = fresh;
    if (!changed) return;
    maybeLoadAll(cartData);
    checkAntiAbuse(cartData);
  }

  function bindButtons(container) {
    Array.prototype.forEach.call(container.querySelectorAll('.upsell-cart__add'), function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.dataset.vid, 10);
        if (!vid || isNaN(vid)) return;
        addUpsellToCart(btn, vid, btn.dataset.name);
      });
    });
  }

  // Sections à rendre sur la page /cart (par data-id, comme le fait cart.js du thème)
  function getCartPageSections() {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var list = [];
    if (itemsEl && itemsEl.dataset.id) list.push(itemsEl.dataset.id);
    list.push('cart-icon-bubble');
    if (footerEl && footerEl.dataset.id) list.push(footerEl.dataset.id);
    return list;
  }

  function addUpsellToCart(btn, vid, name) {
    btn.classList.add('is-added');
    btn.textContent = '\u2713 Ajout\u00e9';
    var isCartPage = !!document.getElementById('main-cart-footer');
    var sections = isCartPage ? getCartPageSections() : ['cart-drawer', 'cart-icon-bubble'];

    fetch('/cart/add.js?sections=' + sections.join(',') + '&sections_url=' + encodeURIComponent(window.location.pathname), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _upsell: 'true' } }] })
    })
    .then(function (res) {
      if (!res.ok) {
        btn.classList.remove('is-added');
        btn.textContent = '+ Ajouter';
        return res.json().then(function (err) { throw err; });
      }
      return res.json();
    })
    .then(function (parsedState) {
      showToast(name);
      if (isCartPage) {
        patchCartPage(parsedState);
      } else {
        patchDrawer(parsedState);
      }
    })
    .catch(function () {
      btn.classList.remove('is-added');
      btn.textContent = '+ Ajouter';
    });
  }

  // Mise à jour de la page /cart (même pattern que cart.js du thème)
  function patchCartPage(parsedState) {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var isEmpty = !parsedState.items || parsedState.items.length === 0;
    if (itemsEl) itemsEl.classList.toggle('is-empty', isEmpty);
    if (footerEl) footerEl.classList.toggle('is-empty', isEmpty);
    var drawerWrapper = document.querySelector('cart-drawer');
    if (drawerWrapper) drawerWrapper.classList.toggle('is-empty', isEmpty);

    var map = [];
    if (itemsEl) map.push({ domId: 'main-cart-items', respKey: itemsEl.dataset.id, selector: '.js-contents' });
    map.push({ domId: 'cart-icon-bubble', respKey: 'cart-icon-bubble', selector: '.shopify-section' });
    if (footerEl) map.push({ domId: 'main-cart-footer', respKey: footerEl.dataset.id, selector: '.js-contents' });

    map.forEach(function (s) {
      var el = document.getElementById(s.domId);
      if (!el) return;
      var target = el.querySelector(s.selector) || el;
      var srcSection = parsedState.sections ? parsedState.sections[s.respKey] : null;
      if (!srcSection) return;
      var src = new DOMParser().parseFromString(srcSection, 'text/html').querySelector(s.selector);
      if (src) target.innerHTML = src.innerHTML;
    });
    // Anti-abuse + upsell avec le panier PLEIN (la réponse add.js n'a que les articles ajoutés)
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (fullCart) {
      var pageContainer = document.getElementById('upsell-block');
      if (pageContainer && fullCart.items.length > 0) {
        delete pageContainer.dataset.upsellLoaded;
        loadUpsellProducts(pageContainer, fullCart);
      }
      syncContainers(fullCart);
      checkAntiAbuse(fullCart);
    }).catch(function () {});
  }

  // Mise à jour du drawer (renderContents natif + is-empty forcé)
  function patchDrawer(parsedState) {
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.renderContents === 'function') {
      try {
        if (!parsedState.cart) parsedState.cart = parsedState;
        drawerEl.renderContents(parsedState);
        // ATTENTION : /cart/add.js?sections= renvoie {items, sections} SANS item_count
        // → détecter le vide via items.length (jamais undefined)
        var items = parsedState.items || [];
        var isEmpty = items.length === 0;
        drawerEl.classList.toggle('is-empty', isEmpty);
        var itemsEl = drawerEl.querySelector('cart-drawer-items');
        if (itemsEl) itemsEl.classList.toggle('is-empty', isEmpty);
        // Anti-abuse + upsell avec le panier PLEIN (la réponse add.js n'a que les articles ajoutés)
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (fullCart) {
          var drawerContainer = document.getElementById('upsell-block-drawer');
          if (drawerContainer && fullCart.items.length > 0) {
            delete drawerContainer.dataset.upsellLoaded;
            loadUpsellProducts(drawerContainer, fullCart);
          }
          syncContainers(fullCart);
          checkAntiAbuse(fullCart);
        }).catch(function () {});
        return;
      } catch (e) { /* fallback reload ci-dessous */ }
    }
    window.location.reload();
  }

  function showToast(name) {
    var p = document.createElement('div');
    p.innerHTML = '<div style="background:#fff;border-radius:12px;padding:14px 22px;box-shadow:0 8px 32px rgba(0,0,0,0.15);display:flex;align-items:center;gap:12px;font-size:13px;color:#333;line-height:1.4"><span style="font-size:26px;flex-shrink:0">\ud83c\udf81</span><p style="margin:0"><strong>' + (name || '') + '</strong> ajout\u00e9 !<br>Le rabais <strong>-20%</strong> est d\u00e9j\u00e0 appliqu\u00e9 sur cet article.</p></div>';
    p.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:999999;opacity:0;transition:opacity 0.4s';
    document.body.appendChild(p);
    requestAnimationFrame(function () { p.style.opacity = '1'; });
    setTimeout(function () { p.style.opacity = '0'; setTimeout(function () { p.remove(); }, 400); }, 3000);
  }

  // Anti-abuse : s'il ne reste AUCUN produit principal (ni upsell, ni catalogue gratuit),
  // on retire TOUT. Vidage + re-rendu en UNE requête (update.js?sections=), reload en secours.
  // PERF v2 : accepte un panier déjà récupéré (cartData) pour éviter un fetch supplémentaire.
  function checkAntiAbuse(cartData) {
    var cartP = isFullCart(cartData)
      ? Promise.resolve(cartData)
      : fetch('/cart.js').then(function (r) { return r.json(); });
    cartP.then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;
      var hasRegular = hasRegularItem(cart);
      var updates = {};
      var needUpdate = false;
      if (!hasRegular) {
        // Plus aucun produit principal : on retire TOUT (upsells + catalogue gratuit)
        cart.items.forEach(function (item) { updates[item.key] = 0; });
        needUpdate = true;
      } else {
        // Sécurité : un produit upsell reste à quantité 1 (pas d'augmentation possible)
        cart.items.forEach(function (item) {
          if (item.properties && item.properties._upsell === 'true' && item.quantity > 1) {
            updates[item.key] = 1;
            needUpdate = true;
          }
        });
      }
      if (!needUpdate) return;

      var isCartPage = !!document.getElementById('main-cart-footer');
      var sections = isCartPage ? getCartPageSections() : ['cart-drawer', 'cart-icon-bubble'];

      fetch('/cart/update.js?sections=' + sections.join(',') + '&sections_url=' + encodeURIComponent(window.location.pathname), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      })
      .then(function (parsedState) {
        if (isCartPage) {
          // Sur /cart, un re-rendu partiel ne montre pas l'état vide natif :
          // on recharge la page (rendu serveur propre, comme le fait déjà le flux
          // natif de suppression qui navigue via /cart/change).
          window.location.reload();
        } else {
          patchDrawer(parsedState);
        }
      })
      .catch(function () { window.location.reload(); });
    }).catch(function () {});
  }

  function cartFingerprint(cart) {
    return cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
  }

  // Détection de TOUT changement de panier. Sur /cart le thème re-rend seulement
  // .js-contents (articles + totaux) SANS remplacer le conteneur upsell :
  // comparer l'empreinte du panier est la seule détection fiable pour l'anti-abuse.
  // PERF v2 : 1 seul fetch /cart.js ; masquage optimiste immédiat si plus de produit
  // principal ; données fraîches passées à maybeLoadAll (pas de re-fetch).
  // PERF v3 : série + coalesce (PAS de debounce affamable). Chaque événement déclenche
  // un fetch SAUF si un fetch est déjà en vol (dans ce cas, l'événement est rejoué à la
  // fin → l'état final est toujours traité). Un debounce classique (60-150 ms) pouvait
  // être affamé par des mutations continues du thème (re-rendus, recs du drawer…) :
  // le timer était réinitialisé sans fin → upsell jamais rechargé après certains ajouts.
  function onCartChange() {
    if (cartCheckInFlight) { cartCheckAgain = true; return; }
    cartCheckInFlight = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var fp = cartFingerprint(cart);
      var changed = fp !== lastCartFingerprint;
      lastCartFingerprint = fp;

      if (changed && cart.items.length > 0 && !hasRegularItem(cart)) {
        // Disparition optimiste : plus aucun produit principal → on masque les offres
        // IMMÉDIATEMENT (perçu instantané), l'update.js suit pour vider le panier.
        hideAllUpsells();
        checkAntiAbuse(cart);
      } else {
        if (changed) {
          // Recharger les conteneurs (drawer + page /cart) avec les données fraîches
          ['upsell-block-drawer', 'upsell-block'].forEach(function (id) {
            var c = document.getElementById(id);
            if (c) delete c.dataset.upsellLoaded;
          });
        }
        // TOUJOURS appeler : le dédoublonnage est assuré par dataset.upsellLoaded
        // (le thème remplace le bloc à chaque re-rendu → fresh sans flag → rechargé).
        maybeLoadAll(cart);
        checkAntiAbuse(cart);
      }
    }).catch(function () {}).then(function () {
      cartCheckInFlight = false;
      if (cartCheckAgain) { cartCheckAgain = false; onCartChange(); }
    });
  }

  function observeChanges() {
    var targets = [
      document.getElementById('CartDrawer'),
      document.getElementById('main-cart-footer'),
      document.getElementById('main-cart-items')
    ];
    targets.forEach(function (target) {
      if (!target) return;
      new MutationObserver(onCartChange).observe(target, { childList: true, subtree: true });
    });
    document.addEventListener('custom:updated', onCartChange);
    document.addEventListener('cart:updated', onCartChange);
  }

  function init() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      lastCartFingerprint = cartFingerprint(cart);
      syncContainers(cart);
      checkAntiAbuse(cart);
    }).catch(function () {
      syncContainers();
      checkAntiAbuse();
    });
    observeChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
